// extracted by mini-css-extract-plugin
module.exports = {"join_appointment_page":"JoinAppointment_join_appointment_page__URe4X","join_appointment_title":"JoinAppointment_join_appointment_title__XYoeV"};